const jsonArray = require(`../../../projects/${process.env.PROJECT}/front/configs/types/rating.json`)

export default () => {
  return jsonArray.map(elem => {
    return {
      type: elem[0],
      value: elem[1]
    }
  })
}



// WEBPACK FOOTER //
// ./src/front/actions/types/get-types-rating.js